import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { http, formatApiError } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { PageHeader } from "@/components/admin/PageBits";

export default function AuditPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { http.get("/admin/audit").then(({ data }) => setRows(data)).catch((e) => toast.error(formatApiError(e))); }, []);
  return (
    <div className="space-y-6">
      <PageHeader title="Auditoria" subtitle="Registro das ações realizadas pelos operadores (últimos 300 eventos)." />
      <div className="overflow-x-auto rounded-md border border-white/[0.06] bg-[#141C2E]">
        <Table data-testid="audit-table">
          <TableHeader>
            <TableRow className="border-white/[0.06] hover:bg-transparent">
              {["Data e hora", "Operador", "Ação", "Alvo", "Detalhes"].map((h) => <TableHead key={h} className="text-xs uppercase tracking-wider text-slate-500">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id} className="border-white/[0.04]" data-testid={`audit-row-${r.id}`}>
                <TableCell className="whitespace-nowrap text-sm text-slate-400">{formatDateTime(r.at)}</TableCell>
                <TableCell className="text-sm">{r.actor?.name || r.actor?.email}</TableCell>
                <TableCell className="font-mono-x text-xs" style={{ color: "var(--brand)" }}>{r.action}</TableCell>
                <TableCell className="font-mono-x text-xs text-slate-500">{r.target ? String(r.target).slice(0, 8) : "—"}</TableCell>
                <TableCell className="max-w-xs truncate font-mono-x text-xs text-slate-500">{Object.keys(r.details || {}).length ? JSON.stringify(r.details) : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
